<template>
  <div class="message-pop" v-show="bShow">
    <div class="dialog-wrapper">
      <p class="title">{{$t(title)}}</p>
      <div class="button-wrapper">
        <button class="confirm" @click="confirm">{{$t('m.confirm')}}</button>
        <button class="cancel" @click="hide">{{$t('m.cancel')}}</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      title: {
        type: String
      },
      classid: {
        type: Number
      }
    },
    data(){
      return {
        bShow: false,
      }
    },
    methods: {
      show() {
        this.bShow = true;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'hidden';
      },
      hide(){
        this.bShow = false;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'auto';
      },
      confirm(){
        this.$emit('confirm',this.classid);
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .message-pop
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    overflow: auto
    .dialog-wrapper
      margin: auto
      padding: 10px 0
      height: 180px
      width: 460px
      border-radius: 4px
      background: #ffffff
      .title
        line-height: 100px
        text-align: center
        font-size: 16px
        color: #000000
      .button-wrapper
        margin: 0 auto
        width: 260px
        font-size: 0
        .confirm, .cancel
          width: 100px
          height: 40px
          line-height: 40px
          font-size: 14px
          text-align: center
          border-radius: 4px
        .confirm
          margin-right: 60px
          color: #ffffff
          background: #3399ff
        .cancel
          color: #333333
          background: #e4e4e4


</style>



// WEBPACK FOOTER //
// src/components/messagepop/MessagePop.vue